import { create } from "zustand"
import { persist } from "zustand/middleware"

interface MainNavState {
	hidden: boolean
	toggle: () => void
	/** The workspace menu in the sidebar header. Not persisted. */
	workspaceMenuOpen: boolean
	setWorkspaceMenuOpen: (open: boolean) => void
	/** The hidden nav slid in over the page from its gutter. */
	peek: boolean
	setPeek: (peek: boolean) => void
	/** Set by the mounted combined sidebar while hidden and not peeking, so the launcher has no nav to sit in. */
	launcherHidden: boolean
	setLauncherHidden: (launcherHidden: boolean) => void
}

export const persistedMainNav = (state: MainNavState) => ({
	hidden: state.hidden,
})

/** The combined sidebar's hidden state. Per browser, like the panel widths. */
export const useMainNavState = create<MainNavState>()(
	persist(
		(set, get) => ({
			hidden: false,
			toggle: () => set({ hidden: !get().hidden, peek: false }),
			workspaceMenuOpen: false,
			setWorkspaceMenuOpen: (open) => set({ workspaceMenuOpen: open }),
			peek: false,
			setPeek: (peek) => set({ peek }),
			launcherHidden: false,
			setLauncherHidden: (launcherHidden) => set({ launcherHidden }),
		}),
		{ name: "main-nav", partialize: persistedMainNav },
	),
)
